export const icons = {
	arrowDown: 'arrowDown.svg',
	assetStarCheck: 'assetStarCheck.svg',
	assetStarChecked: 'assetStarChecked.svg',
	close: 'close.svg',
	closeDrc: 'closeDrc.svg',
	closePanel: 'closePanel.svg',
	defaultAva: 'default-ava.png',
	info: 'info.svg',
	infoDark: 'infoDark.svg',
	moon: 'moon.svg',
	search: 'search.svg',
	sun: 'sun.svg',
	sunDark: 'sunDark.svg'
}
